import React from "react";
import PropTypes from "prop-types";

const List = ({ list }) => {
  return (
    <ul className="ml-6 mt-4 list-disc space-y-2 leading-relaxed">
      {list.map((data, index) => (
        <li key={index}>{data}</li>
      ))}
    </ul>
  );
};

List.propTypes = {
  list: PropTypes.array,
};

export default List;
